import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ViewStreamComponent from '../../components/VideoStream';
import { Button, message, Tabs } from 'antd';
import { useHistory } from 'react-router-dom';
import colorsDark from '../../assets/colors/dark';
import { socketEmitEvent } from '../../redux/actions';
import { useTranslation } from 'react-i18next';
import { EditOutlined } from '@ant-design/icons';
import * as SERVICE from '../../constants/service.types';
import { VIEW_STREAM_SERVICE_EXTEND, ZOOM_STATE, } from '../../constants/system.keys';
import LocationSearchLocationIQ from '../../components/LocationSearchLocationIQ';
import { onlyLettersAndNumbers } from '../../helpers/groupByCoors';

const { TabPane } = Tabs;

const InfoWindowCameraComponent = ({ devices, internalGateways, setKeyMap }) => {
  const { namespace, updateDevice } = useSelector((state) => state);
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [listCamera, setListCamera] = useState(devices);
  const [isEditNote, setIsEditNote] = useState(false);
  const [address, setAddress] = useState({
    note: '',
    lat: 0,
    lng: 0,
  });
  const [isBlock, setIsBlock] = useState(false);
  const [requestId, setRequestId] = useState(new Date().getTime());

  useEffect(() => {
    if (devices) {
      setListCamera(devices);
    }
  }, [devices]);

  useEffect(() => {
    if (updateDevice && updateDevice.requestId === requestId) {
      setKeyMap(Math.random())
    }
  }, [updateDevice]);

  const compare = (a, b) => {
    if (a.resolution > b.resolution) {
      return -1;
    }
    if (a.resolution < b.resolution) {
      return 1;
    }
    return 0;
  }

  const onCheckZoomState = (dataArr, zoomState, zoomStateDefault, resolutionDefault) => {
    if (zoomState >= 0) {
      if (dataArr?.find(item => item.zoomState === zoomState)) {
        return {
          dataZoomStates: [...dataArr],
          zoomState,
          resolution: dataArr?.find(item => item.zoomState === zoomState)?.resolution
        }
      } else {
        return onCheckZoomState(dataArr, zoomState - 1, zoomStateDefault, resolutionDefault)
      }
    } else {
      return {
        dataZoomStates: [...dataArr],
        zoomState: zoomStateDefault,
        resolution: resolutionDefault
      }
    }
  }

  const onZoomState = (camera) => {
    let dataZoomState = (camera?.subSources && JSON.parse(camera?.subSources)?.map(item => ({ resolution: item.resolution, zoomState: item.zoomState }))) ?? []
    if (!dataZoomState?.find(item => item.resolution === camera?.resolution)) {
      dataZoomState = [
        ...dataZoomState,
        {
          resolution: camera?.resolution,
          zoomState: camera?.zoomState
        }
      ]
    }
    const dataArr = dataZoomState?.filter(item => item.resolution >= 0 && item.zoomState >= 0)?.sort(compare)
    const zoomState = ZOOM_STATE.THREE
    const dataTemp = onCheckZoomState(dataArr, zoomState, camera?.zoomState, camera?.resolution)
    return dataTemp
  }

  const handleAddressChange = (address) => {
    setAddress((state) => ({
      ...state,
      note: address,
    }));
  };

  const handleSelect = (address) => {
    setAddress(address);
  };

  const handleResetLocation = () => {
    setIsEditNote(false)
    setAddress({
      note: '',
      lat: 0,
      lng: 0,
    })
  }

  const handleOnUpdateNote = (value) => {
    if (onlyLettersAndNumbers(address.note)) {
      const dataUpdate = {
        name: value.name,
        note: address.note,
        serial: value.serial,
        lat: address.lat,
        lng: address.lng,
      };
      const dataTimeRequest = new Date().getTime();
      setRequestId(dataTimeRequest)
      let dataObj = {
        appServiceType: SERVICE.UPDATE_DEVICE,
        requestId: dataTimeRequest,
        body: JSON.stringify({ ...dataUpdate, namespace }),
      };
      handleResetLocation();
      return dispatch(socketEmitEvent(dataObj));
    } else {
      message.warning(t('Please enter only letters and numbers!'));
    }

  }

  return (
    <div className="info-window-device">
      <Tabs
        defaultActiveKey={'0'}
        tabPosition="bottom"
        size="small"
        style={{ maxWidth: 360 }}
        onChange={() => handleResetLocation()}
      >
        {listCamera &&
          listCamera.map((camera, index) => (
            <TabPane tab={camera.name} key={index}>
              <div
                style={{ color: colorsDark.$darkest }}
                className="main-view-camera"
              >
                <ViewStreamComponent
                  name={camera.name}
                  typeCamera={camera.typeCamera}
                  resolution={camera.resolution}
                  zoomState={onZoomState(camera)}
                  serviceId={VIEW_STREAM_SERVICE_EXTEND.normal}
                  thumbnail={camera.thumbnail}
                  state={camera.state}
                  serial={camera && camera.serial}
                  gatewaySerial={camera.gatewaySerial}
                  isInternal={internalGateways.some(
                    (gateway) => gateway.serial === camera.gatewaySerial
                  )}
                  permission={camera.permission}
                  isAllowStreaming={camera.isAllowStreaming}
                />
                <div className="info-view-camera">
                  <div className="name-camera"> Camera: {camera.name}</div>
                  <div className="detail-camera">
                    <Button
                      onClick={() =>
                        history.push(
                          `/camera?redirect=true&camera=${camera.name}#key=${camera.serial}`
                        )
                      }
                      type="primary"
                      size="small"
                    >
                      {t('Records')}
                    </Button>
                  </div>
                </div>
                <div className="note-camera">
                  {isEditNote ? (
                    <LocationSearchLocationIQ
                      address={address.note}
                      onChange={handleAddressChange}
                      onAddressSelect={handleSelect}
                      setIsBlock={setIsBlock}
                    />
                  ) : (
                    camera.note ? camera.note : 'Note empty'
                  )}
                  {isEditNote ? (
                    <div style={{ padding: '6px 0px 0px 8px' }}>
                      <span
                        style={{ marginRight: '10px', cursor: 'pointer', color: '#0E9347' }}
                        onClick={() => handleOnUpdateNote(camera)}
                      >{t('Update')}</span>
                      <span
                        style={{ cursor: 'pointer', color: '#4F4D4D' }}
                        onClick={() => handleResetLocation()}
                      >{t('Cancel')}</span>
                    </div>
                  ) : (<EditOutlined
                    style={{ marginLeft: '8px', cursor: 'pointer' }}
                    onClick={() => {
                      setIsEditNote(true)
                      setAddress((state) => ({
                        ...state,
                        note: camera.note ? camera.note : '',
                      }));
                    }}
                  />)}
                </div>
              </div>
            </TabPane>
          ))}
      </Tabs>
    </div>
  );
};

export default InfoWindowCameraComponent;
